import styled from 'styled-components';
import { Modal, Button } from 'react-bootstrap';

export const StyledModal = styled(Modal)`
  .modal-dialog {
    max-width: 600px;
  }
`;

export const ModalContent = styled.div``;

export const ModalHeader = styled(Modal.Header)`
  background: #ffffff !important;
  border-bottom: 1px solid #d6d9dd !important;
  padding: 24px !important;

  .btn-close {
    opacity: 0.5;
    &:hover { opacity: 0.8; }
  }
`;

export const ModalTitle = styled(Modal.Title)`
  font-family: 'Titillium Web', sans-serif;
  font-weight: 600;
  font-size: 1rem;
  color: #141726 !important;
`;

export const ModalBody = styled(Modal.Body)`
  padding: 24px !important;
  background: #ffffff !important;
`;

export const ModalFooter = styled(Modal.Footer)`
  background: #ffffff !important;
  border-top: 1px solid #d6d9dd !important;
  padding: 16px 24px !important;
  display: flex !important;
  justify-content: flex-end !important;
  gap: 8px !important;
`;

export const FormSection = styled.div`
  .form-label {
    font-size: 0.875rem;
    font-weight: 500;
    color: #a3a5a9;
    margin-bottom: 6px;
  }

  .form-control {
    border: 1px solid #e9ecef;
    border-radius: 4px;
    padding: 8px 12px;
    font-size: 0.875rem;
    color: #4d5c6d;
    background-color: #ffffff;

    &:focus {
      outline: none;
      border-color: #fcb12e;
      box-shadow: none;
    }

    &:disabled {
      background-color: #f5f5f5;
      cursor: not-allowed;
      opacity: 0.6;
    }

    &::placeholder {
      color: #a3a5a9;
      font-size: 0.875rem;
    }
  }

  .form-text {
    font-size: 0.75rem;
    color: #a3a5a9;
    margin-top: 6px;

    a {
      color: #9f173e;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .invalid-feedback {
    font-size: 0.75rem;
  }
`;

export const SectionTitle = styled.h4`
  font-family: 'Titillium Web', sans-serif;
  font-size: 0.875rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
`;

export const SectionDescription = styled.p`
  font-size: 0.8rem;
  color: #a3a5a9;
  margin-bottom: 16px;
  line-height: 1.5;
`;

export const ChannelList = styled.div`
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #eeeeee;
  border-radius: 8px;
  background: #ffffff;
`;

export const ChannelItem = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 12px 14px;
  border-bottom: 1px solid #eeeeee;
  transition: background 0.15s ease;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #f8f8f8;
  }

  .form-check {
    margin: 0;
    width: 100%;
  }

  .form-check-input {
    border-color: #d0d0d0;

    &:checked {
      background-color: #9f173e;
      border-color: #9f173e;
    }

    &:focus {
      border-color: #9f173e;
      box-shadow: 0 0 0 2px rgba(159, 23, 62, 0.15);
    }
  }

  .form-check-label {
    cursor: pointer;
    width: 100%;
  }
`;

export const ChannelName = styled.div`
  font-weight: 500;
  font-size: 0.875rem;
  color: #333;
`;

export const ChannelDescription = styled.div`
  font-size: 0.75rem;
  color: #a3a5a9;
  margin-top: 2px;
  line-height: 1.4;
`;

export const TeamsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 24px;
`;

export const TeamItem = styled.div`
  padding: 12px 16px;
  border-radius: 8px;
  background: ${props => props.$active ? 'rgba(159, 23, 62, 0.08)' : '#ffffff'};
  border: 1px solid ${props => props.$active ? '#9f173e' : '#eeeeee'};
  cursor: pointer;
  transition: all 0.15s ease;
  font-size: 0.875rem;
  color: ${props => props.$active ? '#9f173e' : '#666'};
  font-weight: ${props => props.$active ? '500' : '400'};

  &:hover {
    background: ${props => props.$active ? 'rgba(159, 23, 62, 0.12)' : '#f8f8f8'};
    border-color: ${props => props.$active ? '#9f173e' : '#e0e0e0'};
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #a3a5a9;

  h5 {
    font-family: 'Titillium Web', sans-serif;
    font-size: 0.875rem;
    font-weight: 600;
    color: #666;
    margin-bottom: 8px;
  }

  p {
    font-size: 0.8rem;
    max-width: 280px;
    margin: 0 auto;
    line-height: 1.5;
  }
`;

export const CancelButton = styled(Button).attrs({
  variant: 'outline-secondary'
})`
  font-size: 0.875rem !important;
  font-weight: 500 !important;
  color: #141726 !important;
  background: transparent !important;
  border: 1px solid #d6d9dd !important;
  border-radius: 6px !important;
  padding: 8px 16px !important;
  min-height: 36px !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05) !important;

  &:hover {
    background: #fafbfd !important;
    border-color: #d6d9dd !important;
    color: #141726 !important;
  }

  &:focus {
    box-shadow: 0 0 0 1px #d6d9dd !important;
    outline: none !important;
  }

  &:active {
    box-shadow: none !important;
  }
`;

export const SaveButton = styled(Button).attrs({
  variant: 'primary'
})`
  font-size: 0.875rem !important;
  font-weight: 500 !important;
  color: #ffffff !important;
  background: #9f173e !important;
  border: 1px solid #9f173e !important;
  border-radius: 6px !important;
  padding: 8px 16px !important;
  min-height: 36px !important;

  &:hover:not(:disabled) {
    background: #8a1436 !important;
    border-color: #8a1436 !important;
    color: #ffffff !important;
  }

  &:disabled {
    opacity: 0.5 !important;
    cursor: not-allowed !important;
  }

  &:focus {
    box-shadow: 0 0 0 2px rgba(159, 23, 62, 0.3) !important;
    outline: none !important;
  }

  &:active:not(:disabled) {
    box-shadow: none !important;
  }
`;

